import {dispatch} from "../store/store";

export const useDownloadManager = () => {
  const start = (label: string, fn: () => Promise<void>) => {
    dispatch.downloadManager.start({label, fn});
  };

  return {start};
};
